import { ObjectDirective } from 'vue';

export const permission: ObjectDirective = {
  mounted(el: HTMLButtonElement, binding) {
    if (binding.value === 'Metadata') {
      el.remove();
    }
  },
};
